<ng-container *workspaceView="'full'">
<div class="workspace-page br-compact-page">
  <div class="workspace-page__panel workspace-page__panel--card">
    <header class="workspace-page__heading">
      <h1 class="workspace-page__title">Smart Workflows</h1>
      <div class="workspace-page__title-actions">
        <button
            type="button"
            class="br-btn br-btn--primary br-btn--sm"
            (click)="createWorkflow()">
          <br-icon>add</br-icon> New workflow
        </button>
      </div>
    </header>

  <app-data-table [(search)]="collectionSearch"
      [columns]="columns"
      [fetch]="fetch"
      [rowIdFn]="workflowRowId"
      [editable]="true"
      [rowActions]="rowActions"
      [resizableColumns]="true"
      columnPickerKey="dynamic-workflows"
      searchPlaceholder="Search workflows…"
      editTooltip="Edit workflow"
      emptyText="No workflows found."
      (edit)="editWorkflow($event)">
    <ng-template dtCell="label" let-workflow>
      <span class="br-cell-primary">{{ workflow.label }}</span>
    </ng-template>

    <ng-template dtCell="status" let-workflow>
      <span class="br-cell-pill">{{ workflow.status | titlecase }}</span>
    </ng-template>

    <ng-template dtCell="createdAt" let-workflow>
      {{ workflow.createdAt | date:'MMM d, y' }}
    </ng-template>

    <ng-template dtCell="updatedAt" let-workflow>
      {{ workflow.updatedAt | date:'MMM d, y' }}
    </ng-template>
  </app-data-table>

  <ng-template #rowActions let-workflow>
    <button
        *ngIf="workflow.status === 'draft'"
        type="button"
        mat-icon-button
        matTooltip="Publish workflow"
        aria-label="Publish workflow"
        [disabled]="statusChangingKeys.has(workflow.key)"
        (click)="publishWorkflow(workflow)">
      <br-icon>publish</br-icon>
    </button>
    <button
        *ngIf="workflow.status === 'published'"
        type="button"
        mat-icon-button
        matTooltip="Unpublish workflow"
        aria-label="Unpublish workflow"
        [disabled]="statusChangingKeys.has(workflow.key)"
        (click)="unpublishWorkflow(workflow)">
      <br-icon>unpublished</br-icon>
    </button>
    <button
        type="button"
        mat-icon-button
        matTooltip="Delete workflow"
        aria-label="Delete workflow"
        (click)="deleteWorkflow(workflow)">
      <br-icon>delete</br-icon>
    </button>
  </ng-template>
  </div>
</div>
</ng-container>

<ng-container *workspaceView="'compact'">
  <section class="workspace-page workspace-page--full">
    <h1 class="workspace-page__title">Smart Workflows</h1>

    <app-data-list #compactList [fetch]="fetch" [(search)]="collectionSearch">

      <ng-template dataListItem let-row>
        <strong>{{ row.label }}</strong>
        <div class="br-text-muted">{{ row.status | titlecase }}</div>
      </ng-template>
      <ng-template dataListDetail let-row>
        <div>Created: {{ row.createdAt | date:'MMM d, y' }}</div>
        <div>Updated: {{ row.updatedAt | date:'MMM d, y' }}</div>
      </ng-template>
    </app-data-list>
  </section>
</ng-container>
